import { render } from "./News01.vue?vue&type=template&id=bcc6b980&scoped=true"
import script from "./News01.vue?vue&type=script&lang=js"
export * from "./News01.vue?vue&type=script&lang=js"

import "./News01.vue?vue&type=style&index=0&id=bcc6b980&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcc6b980"]])

export default __exports__